// Rider reputation: title ladder, computed from VERIFIED platform
// activity only (QR check-ins, published content, ratings) so it can't be
// typed into existence. Thresholds live here — tune freely.
//
// Stats shape (from getRiderReputation):
//   { ridesAttended, ridersGuided, toursLed, toursHosted,
//     routesPublished, routeRatings, avgRouteRating, curvyRoutes,
//     longestRouteKm, memberSince }

// ── Title ladder (motorcycle-club flavoured) ─────────────────────────────────
// score = weighted verified contribution.
export function reputationScore(s) {
  return (
    (s.ridesAttended  || 0) * 2 +
    (s.ridersGuided   || 0) * 3 +
    (s.toursHosted    || 0) * 3 +
    (s.routesPublished|| 0) * 2 +
    (s.routeRatings   || 0)
  );
}

const TITLES = [
  { min: 120, label: 'Legend' },
  { min: 50,  label: 'Road Captain' },
  { min: 20,  label: 'Pathfinder' },
  { min: 5,   label: 'Rider' },
  { min: 0,   label: 'Prospect' },
];

export function riderTitle(stats) {
  const score = reputationScore(stats);
  return TITLES.find(t => score >= t.min)?.label ?? 'Prospect';
}
